import script from "./FormConsulta.vue?vue&type=script&setup=true&lang=js"
export * from "./FormConsulta.vue?vue&type=script&setup=true&lang=js"

import "./FormConsulta.vue?vue&type=style&index=0&id=02eff4ba&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02eff4ba"]])

export default __exports__